
export const sFechaPublicacion = '2026-02-27T12:24:09.2221259-06:00';
export const sVersion = 'vf1.1.602271224';
            